import React from 'react';
import styled from '@emotion/styled';
import { Box } from '@mantine/core';

import { mediaQueryMobile, mediaQueryTablet } from '~/styles/mixins';

import { LabelLargeStrong, LabelSmall, ParagraphLarge } from '../typography';

const Flex = styled(Box)`
  display: flex;
`;

const Root = styled(Box)`
  position: relative;
  height: 372px;
  border-radius: 8px;
  padding: 48px 64px 48px;
  margin: 0 auto;
  background: #b1611f;
  background: ${(props) => `${props.overlay}, url('${props.userAvatar}') no-repeat bottom right`};
  background-size: 100% auto, contain;
  ${mediaQueryTablet} {
    background-size: 100% auto, 45%;
  }
  ${mediaQueryMobile} {
    min-height: 456px;
    padding: 32px 32px 48px;
  }
`;

const TextContainer = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  max-width: 596px;
  height: 100%;
  ${mediaQueryMobile} {
    max-width: 100%;
  }
`;

const ImgContainer = styled.img`
  display: block;
  height: 32px;
  object-fit: cover;
  overflow: hidden;
`;

const CompanyLogo = styled(ImgContainer)`
  height: 32px;
  flex-shrink: 0;
`;

const UserTestimonial = ({ testimonial }) => {
  return (
    <Root overlay={testimonial.background} userAvatar={testimonial.userAvatar}>
      <TextContainer>
        <Box>
          <CompanyLogo src={testimonial.companyLogo} alt={testimonial.companyName} />
          <ParagraphLarge style={{ marginTop: '24px', color: '#FFFFFF', letterSpacing: '-0.015em' }}>
            {testimonial.testimonialText}
          </ParagraphLarge>
        </Box>
        <Box>
          <LabelLargeStrong color="#fff">{testimonial.name}</LabelLargeStrong>
          <LabelSmall color="#ffffff70">
            {testimonial.designation} at {testimonial.companyName}
          </LabelSmall>
        </Box>
      </TextContainer>
    </Root>
  );
};

export default UserTestimonial;
